import { useTheme } from '@mui/material';
const useAppearanceStyles = () => {
    const theme = useTheme();
    const headerHeight = '48px';
    const bottomNavigationHeight = '56px';
    return {
        appearanceSectionStyles: {
            display: 'flex',
            flexDirection: 'column',
            p: 2,
            height: `calc(100dvh - ${headerHeight} - ${bottomNavigationHeight})`,
            overflowY: 'auto',
            position: 'relative'
        },
        appearanceHeaderStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        imageStyles: {
            width: '100%',
            height: 'auto',
            objectFit: 'cover'
        },
        themeContentContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        },
        themeSelectorContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        },
        themeContainerStyles: {
            mt: 2,
            'label': {
                m: 0,
            }
        },
        themeRadioGroupStyles: {
            display: 'flex',
            flexDirection: 'row !important',
            flexWrap: 'unset !important',
            gap: '20px',
        }
    };
};
export default useAppearanceStyles;
